export default class Faturamento {
  constructor(id, descricao, cliente, orcamento, data, nota, total, pago) {
    this.id = id;
    this.descricao = descricao;
    this.cliente = cliente;
    this.orcamento = orcamento;
    this.data = data;
    this.nota = nota;
    this.total = total;
    this.pago = pago;
  }

  update(faturamento) {
    this.id = faturamento.id;
    this.descricao = faturamento.descricao;
    this.cliente = faturamento.cliente;
    this.orcamento = faturamento.orcamento;
    this.data = faturamento.data;
    this.nota = faturamento.nota;
    this.total = faturamento.total;
    this.pago = faturamento.pago;
  }

  setNumber() {
    let numero = Number(this.total.replace("R$ ", "").replaceAll(".", "").replace(",", "."));
    this.total = parseFloat(numero).toFixed(2);
  }
}
